<script lang="ts">
	import { tooltip } from "tooltip"

	let { title, url, img } = $props()
</script>

<a href={url} target="_blank">
	<button class="custom-select-instance" use:tooltip={{ content: title, pointing: "top" }}>
		<img src={img} alt="title" />
	</button>
</a>

<style>
	.custom-select-instance {
		position: relative;
		border-radius: 0.5rem;
		background-color: var(--color-bg-dark);
		min-width: 10rem;
		width: 12vw;
		min-height: 4rem;
		height: 100%;
	}

	a {
		border: none;
	}

	img {
		object-fit: contain;
		height: 100%;
		width: auto;
	}

	button:hover {
		background-color: var(--color-bg-dark-transparent);
		transform: unset;
	}
</style>
